export const CONTENT_CONSTANTS = {
  ALL: "ALL",
  LANG: "lang",
  PUBLISHED: "PUBLISHED",
  PUBLISH: "PUBLISH",
  DRAFT: "DRAFT",
  UNPUBLISHED: "UNPUBLISHED",
  QUIZ: "Quiz",
  QUESTION: "Question",
  POLL: "Poll",
  EVENT: "Event",
  PREVIEW_PATH: "/content/preview",
  ARTICLE: "Article",
  VOD: "Vod",
};

export const ROW_SIZE: number = 20;
